import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';

const RestartSession = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const restartDataString = sessionStorage.getItem('restartData');

    /*if (!restartDataString) {
      navigate('/courses', { replace: true });
      return;
    }*/

    try {
      const restartData = JSON.parse(restartDataString);

      // Remove restart data temporarily
      sessionStorage.removeItem('restartData');

      // Clear storage
      //localStorage.clear();
      //sessionStorage.clear();

      // Restore session values
      sessionStorage.setItem(
        'activityInstance',
        restartData.activityInstance
      );

      sessionStorage.setItem(
        'userid',
        restartData.userid
      );

      sessionStorage.setItem(
        'username',
        restartData.username
      );

      sessionStorage.setItem(
        'userEmail',
        restartData.userEmail
      );

      sessionStorage.setItem(
        'activityID',
        restartData.activityID
      );

      sessionStorage.setItem(
        'navigation',
        restartData.navigation
      );

      sessionStorage.setItem(
        'jswtoken',
        restartData.token
      );

    localStorage.setItem('userid', restartData.userid);
    localStorage.setItem('username', restartData.username);
    localStorage.setItem('userEmail', restartData.userEmail);
    localStorage.setItem('activityID', restartData.activityID);
    localStorage.setItem('courseIdselected', restartData.activityInstance);

      navigate(restartData.pathname, {
        replace: true,
        state: {
          ...restartData.state,
          replay: true,
          reloadKey: Date.now()
        }
      });
    } catch (error) {
      console.error('Restart failed', error);
     // navigate('/courses', { replace: true });
    }
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        height: '100vh'
      }}
    >
      <CircularProgress />
      <Typography sx={{ mt: 2 }}>
        Restarting activity...
      </Typography>
    </Box>
  );
};

export default RestartSession;